type ailasnumber = number | null | undefined;
type aliasstring = string | null | undefined;
type aliasDate = Date | null | undefined;
export class FileLocationModel {
  FTPFolderId: ailasnumber
  BusinessUnitId: ailasnumber
  FolderName: aliasstring
  AccountName: aliasstring
  FileLocationType: aliasstring
  Location: aliasstring
  ServerName: aliasstring
  Port: ailasnumber
  UserName: aliasstring
  Password: aliasstring
  AccountId: ailasnumber
  EnableBackup: boolean | null | undefined;
  CreatedBy: ailasnumber
  Active: ailasnumber
  OrderBy: ailasnumber
  Protocol?: ailasnumber
  LastModifiedDate: aliasDate
  CreatedDate: aliasDate
  BackUpPath: aliasstring
  SearchText: aliasstring
  FileFormat: aliasstring
  SuperAdmin: ailasnumber
  ListEmailTemplateModel: FileLocationModel[] | null | undefined;
  RecordCount: ailasnumber
  ParentFTPFolderId?: ailasnumber
  ContextName: aliasstring
  CurrentPage: ailasnumber
  NoOfRecords: ailasnumber
}

export class FileLocationContextModel {
  ContextName: aliasstring
  ObjFileLocationModel: FileLocationModel[] | undefined;
}
